import { combineReducers, createReducer } from '@reduxjs/toolkit';
import {
	SET_DATA_SOURCES,
	SET_ETFS,
	SET_SETTING_COLOR,
	SET_SETTING_CURRENCY,
	SET_SETTING_GROUP_LEVEL1,
	SET_SETTING_GROUP_LEVEL2,
	SET_SETTING_SIZE,
	SET_SETTING_TRADE_STATUS,
	SET_TREE_ROOT
} from './redux-actions';
import { EtfState, ReturnMapSettings, ReturnMapTree, ReturnsMapStore } from './redux-model';
import {defaultDataSources, IReturnMapDataSources} from "./dataSources";
import {SelectItemViewModel} from "../../../shared/ui-kit";

const etfsReducer = createReducer<EtfState>(
	{ isLoaded: false, all: [] },
	builder => builder
		.addCase(SET_ETFS, (state, action) => {
			state.isLoaded = true;
			state.all = action.payload;
		})
);

const settingsReducer = createReducer<ReturnMapSettings>(
	{ currency: 'RUB', color: '1day', size: 'assetsUnderManagement', groupLevel1: 'assetClass', groupLevel2: 'region', tradeStatus: 'Торгуется' },
	builder => builder
		.addCase(SET_SETTING_CURRENCY, (state, action) => { state.currency = action.payload; })
		.addCase(SET_SETTING_COLOR, (state, action) => { state.color = action.payload; })
		.addCase(SET_SETTING_SIZE, (state, action) => { state.size = action.payload; })
		.addCase(SET_SETTING_GROUP_LEVEL1, (state, action) => { state.groupLevel1 = action.payload; })
		.addCase(SET_SETTING_GROUP_LEVEL2, (state, action) => { state.groupLevel2 = action.payload; })
		.addCase(SET_SETTING_TRADE_STATUS, (state, action) => { state.tradeStatus = action.payload; })
);

const treeReducer = createReducer<ReturnMapTree>(
	{ root: null },
	builder => builder
		.addCase(SET_TREE_ROOT, (state, action) => { state.root = action.payload })
);

const dataSources = createReducer<IReturnMapDataSources>(
	defaultDataSources,
	builder => builder
		.addCase(SET_DATA_SOURCES, (state, action) => {
			const allTradeStatuses = action.payload
				.map(x => x.tradeStatus)
				.filter(x => x)
				.map(x => x!)
				.sort((a, b) => a.sortOrder - b.sortOrder)
				.map(x => x.name);

			const uniqueTradeStatuses = allTradeStatuses
				.filter((x, index) => allTradeStatuses.indexOf(x) === index)

			state.tradeStatuses = {
				items: [<SelectItemViewModel>{ key: '', text: 'Любой статус' }].concat(uniqueTradeStatuses.map(x => <SelectItemViewModel>{ key: x, text: x }))
			};
		})
)

export const StoreReducer = combineReducers<ReturnsMapStore>({
	etfs: etfsReducer,
	settings: settingsReducer,
	tree: treeReducer,
	dataSources: dataSources 
});